import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import CampusDining from './pages/CampusDining';
import Athletics from './pages/Athletics';
import MainCampus from './pages/MainCampus';
import DormRooms from './pages/DormRooms';
import ConferenceBallroom from './pages/ConferenceBallroom';
import DetailPage from './pages/DetailPage';
import Solution from './pages/Solution';
import AboutUs from './pages/AboutUs';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="campus-dining" element={<CampusDining />} />
        <Route path="campus-dining/kitchen" element={<DetailPage pageId="kitchen" />} />
        <Route path="campus-dining/dining-hall" element={<DetailPage pageId="dining-hall" />} />
        <Route path="campus-dining/food-court" element={<DetailPage pageId="food-court" />} />
        <Route path="athletics" element={<Athletics />} />
        <Route path="athletics/seats" element={<DetailPage pageId="seats" />} />
        <Route path="athletics/concessions" element={<DetailPage pageId="concessions" />} />
        <Route path="main-campus" element={<MainCampus />} />
        <Route path="main-campus/gift-shop" element={<DetailPage pageId="gift-shop" />} />
        <Route path="main-campus/classrooms" element={<DetailPage pageId="classrooms" />} />
        <Route path="main-campus/shipping-receiving" element={<DetailPage pageId="shipping-receiving" />} />
        <Route path="dorm-rooms" element={<DormRooms />} />
        <Route path="conference-and-ballroom" element={<ConferenceBallroom />} />
        <Route path="solutions/:id" element={<Solution />} />
        <Route path="aboutus" element={<AboutUs />} />
        <Route path="aboutus/agilysys" element={<AboutUs />} />
      </Route>
    </Routes>
  );
}

export default App;
